import Api from "../../lib/api";

export const ACTIVITIES_LIST = {
  start: "fetch_start/activities_list",
  end: "fetch_end/activities_list",
  success: "fetch_success/activities_list",
  failed: "fetch_failed/activities_list",
};

export const activitiesListFetchStart = () => ({
  type: ACTIVITIES_LIST.start,
});

export const activitiesListFetchEnd = () => ({
  type: ACTIVITIES_LIST.end,
});

export const activitiesListFetchSuccess = (data) => ({
  type: ACTIVITIES_LIST.success,
  data,
});

export const activitiesListFetchFailed = (error) => ({
  type: ACTIVITIES_LIST.failed,
  error,
});

export const updateActivitiesList = (
  year,
  page,
  pageSize,
  portal,
  field_of_operation,
  donor,
  oecd,
  sdg
) => (dispatch) => {
  dispatch(activitiesListFetchStart());
  const filterPortal = portal || "";
  const filterField_of_operation = field_of_operation || "";
  const filterDonor = donor || "";
  const filterOecd = oecd || "";
  const filterSdg = sdg || "";
  if (year !== null) {
    return Api.get(
      Api.API_ACTIVITIES_LIST(
        year,
        page,
        pageSize,
        filterPortal,
        filterField_of_operation,
        filterDonor,
        filterOecd,
        filterSdg
      )
    )
      .then((response) => {
        dispatch(activitiesListFetchEnd());
        dispatch(activitiesListFetchSuccess(response.data));
      })
      .catch((exception) => {
        dispatch(activitiesListFetchEnd());
        dispatch(activitiesListFetchFailed(exception));
      });
  }
};



// WEBPACK FOOTER //
// ./shared/actions/getActivitiesList.js